import { render, staticRenderFns } from "./categoryWhat.vue?vue&type=template&id=db88013c&"
import script from "./categoryWhat.vue?vue&type=script&lang=js&"
export * from "./categoryWhat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports